import React, {Component, useRef} from "react";
import SVG from 'react-inlinesvg';
import rightArrow from '../../assets/chevron-right-solid.svg';

const AccordionItem = ({title, data, onToggle, active, onSelect}) => {
    const contentEl = useRef(null);
    return (
        <li className={`accordion-item ${active ? "active" : ""}`}>
            <div className="accordion-header" onClick={onToggle}>
                <p>{title}</p>
                <button className="accordion-button">
                    <SVG src={rightArrow}/>
                </button>
            </div>
            <div className={`options-wrapper ${active ? 'open' : ''}`}>
                <div className="inner-options-wrapper">
                    {data.map((it, index) => {
                       return(<div key={index} className="options" onClick={() => onSelect(it)}>{it.name}</div>)
                    })}
                </div>
            </div>
        </li>
    );
};

export default AccordionItem;